import { mainSiteUrl } from "@/mocks/categories";

export default function CTASection() {
  return (
    <section className="relative w-full py-24 md:py-32 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Beautifully%20arranged%20fashion%20product%20collection%20on%20neutral%20textured%20background%20sneakers%20with%20streetwear%20hoodies%20and%20jackets%20folded%20neatly%20casual%20accessories%20scattered%20organically%20warm%20cream%20and%20beige%20color%20palette%20soft%20diffused%20lighting%20from%20large%20window%20high%20end%20editorial%20catalog%20photography%20clean%20minimal%20composition%20lifestyle%20product%20display%20with%20aspirational%20mood&width=1920&height=1080&seq=cta-bg-superbuy-v2&orientation=landscape"
        alt="Superbuy Spreadsheet product collection"
        className="absolute inset-0 w-full h-full object-cover object-top"
        title="Explore Superbuy Spreadsheet Resources"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 text-center">
        <h2 className="text-2xl md:text-5xl font-bold font-heading text-background-50 mb-4 max-w-3xl mx-auto leading-tight">
          Ready To Explore Superbuy Spreadsheet Resources?
        </h2>
        <p className="text-sm md:text-base text-background-200/90 max-w-md mx-auto mb-8">
          Thousands of shoppers are already using structured research to make smarter buying decisions. Join them today.
        </p>
        <a
          href={mainSiteUrl}
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-2 text-sm font-semibold text-background-50 bg-accent-500 hover:bg-accent-600 px-8 py-3.5 rounded-full transition-all whitespace-nowrap cursor-pointer"
        >
          <i className="ri-shopping-bag-3-line text-base"></i>
          Visit Our Main Website
          <i className="ri-arrow-right-up-line text-base"></i>
        </a>
      </div>
    </section>
  );
}